// タブ切り替え（WAI-ARIA Tabs パターン）
//
// マークアップ:
//   [role="tablist"]
//     .js-tab[role="tab"][aria-controls="<パネルID>"]  … タブ。選択中は .-active / aria-selected="true" / tabindex="0"
//   .js-tab-panel[role="tabpanel"]#<パネルID>         … パネル。表示中は .-active
//
// - タブとパネルは aria-controls で対応付ける（DOM の並び順に依存しない）
// - 1ページに複数のタブグループがあっても、グループごとに独立して動く
// - マウス・Enter・Space は click で切り替える（keyup を別に拾うと二重実行になるため拾わない）
// - 矢印キー / Home / End は keydown で隣のタブへ移動して切り替える
// - 選択中のタブを再度押しても何もしない（クラスの付け直しによる再描画を避ける）

const KEY_TO_OFFSET = { ArrowRight: 1, ArrowLeft: -1 };

export const initTabs = () => {
  document.querySelectorAll('[role="tablist"]').forEach(tablist => {
    const tabs = [...tablist.querySelectorAll('.js-tab')];
    if (!tabs.length) return;

    const panelOf = tab => document.getElementById(tab.getAttribute('aria-controls'));

    const activate = (nextTab, { focus = false } = {}) => {
      if (!nextTab.classList.contains('-active')) {
        tabs.forEach(tab => {
          const isActive = tab === nextTab;
          tab.classList.toggle('-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
          const panel = panelOf(tab);
          if (panel) panel.classList.toggle('-active', isActive);
        });
      }
      if (focus) nextTab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));

      tab.addEventListener('keydown', event => {
        let nextIndex;
        if (event.key in KEY_TO_OFFSET) {
          nextIndex = (index + KEY_TO_OFFSET[event.key] + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }
        event.preventDefault();
        activate(tabs[nextIndex], { focus: true });
      });
    });
  });
};
